import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import FeaturedWireContext from '../context';
import { useRemovePrimaryImage } from '../../../../../../services/wire/primary-image-services';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Anchor = styled.a`
  text-transform: uppercase;
  margin-top: 5px;
  font: ${props => props.theme.fontWeightBold} 8px/120% ${props => props.theme.fontFamilyBody};
  color: ${props => props.theme.secondaryColor};
`;

const Image = styled.img`
  border: 1px solid #cdd7e1;
  ${props => (props.theme.isMobile ? `
    width: 100%;
  ` : `
    width: 120px;
    height: 67.5px;
  `)};
`;

export default function PrimaryImage(props) {
  const { dispatch } = React.useContext(FeaturedWireContext);
  const [, remove] = useRemovePrimaryImage(props.id);

  const clickHandler = e => {
    e && e.preventDefault();
    remove().then(() => dispatch({
      type: 'updateWire',
      payload: {
        ...props,
        removable: false,
        primaryImageUrl: null,
      },
    }));
  };

  return props.removable
    ? (
      <Container>
        <Image src={props.primaryImageUrl} />
        <Anchor href="#" onClick={clickHandler}>remove image</Anchor>
      </Container>
    )
    : <Image src={props.primaryImageUrl} />;
}

/* eslint-disable react/no-unused-prop-types */
PrimaryImage.propTypes = {
  id: PropTypes.number.isRequired,
  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  contributor: PropTypes.shape({
    name: PropTypes.string.isRequired,
    organization: PropTypes.string,
  }).isRequired,
  primaryImageUrl: PropTypes.string.isRequired,
  removable: PropTypes.bool,
};
/* eslint-enable react/no-unused-prop-types */

PrimaryImage.defaultProps = {
  removable: false,
};
